// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { ComponentPropsWithoutRef, forwardRef, ReactNode } from 'react'
import { colors, Typography } from '@teamnine/pcj-ui-v2'

import * as Styled from './Styles'

type LinkButtonProps = {
  icon?: ReactNode
  label: string
} & Omit<ComponentPropsWithoutRef<'button'>, 'children'>

const LinkButton = forwardRef<HTMLButtonElement, LinkButtonProps>(
  function LinkButton({ icon, label, ...rest }, ref) {
    return (
      <Styled.Wrapper ref={ref} type="button" {...rest}>
        {icon}
        <Typography variant="body-m-regular" color={colors.ngblue600}>
          {label}
        </Typography>
      </Styled.Wrapper>
    )
  }
)

export default LinkButton
